/* DrOff — interacciones de la plantilla (galería, ofertas, compra, upsells, videos, barras) */
(function () {
  if (window.__dxLoaded) return;
  window.__dxLoaded = true;

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initGallery(root) {
    var track = root.querySelector('[data-track]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    if (!track) return;
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      });
    });
    var tick;
    track.addEventListener('scroll', function () {
      clearTimeout(tick);
      tick = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        var a = thumbs[i];
        if (a && a.parentNode) a.parentNode.scrollTo({ left: a.offsetLeft - 20, behavior: 'smooth' });
      }, 60);
    });
  }

  function initProduct(root) {
    var form = root.querySelector('[data-dx-form]');
    var idInput = form && form.querySelector('input[name="id"]');
    var qtyInput = form && form.querySelector('input[name="quantity"]');
    var cta = root.querySelector('[data-dx-cta]');
    var ctaTpl = cta ? cta.getAttribute('data-template') : '';
    var offers = root.querySelectorAll('[data-offer]');
    var mode = root.getAttribute('data-cta-mode') || 'checkout';

    function select(o) {
      offers.forEach(function (x) { x.classList.toggle('is-active', x === o); });
      var inp = o.querySelector('input'); if (inp) inp.checked = true;
      if (idInput && o.dataset.variant) idInput.value = o.dataset.variant;
      if (qtyInput) qtyInput.value = o.dataset.qty || 1;
      if (cta && ctaTpl) cta.querySelector('span').textContent = ctaTpl.replace('[precio]', o.dataset.price || '');
    }
    offers.forEach(function (o) {
      o.addEventListener('click', function () { select(o); });
    });
    var start = root.querySelector('[data-offer].is-active') || offers[0];
    if (start) select(start);

    if (form && mode === 'checkout') {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (cta) cta.disabled = true;
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: Number(qtyInput.value || 1) }] })
        }).then(function (r) {
          if (!r.ok) throw r;
          window.location.href = '/checkout';
        }).catch(function () {
          if (cta) cta.disabled = false;
          form.submit();
        });
      });
    }

    root.querySelectorAll('[data-upsell]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.classList.contains('is-done')) return;
        b.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(b.dataset.upsell), quantity: 1 }] })
        }).then(function (r) {
          b.disabled = false;
          if (r.ok) { b.classList.add('is-done'); b.textContent = b.dataset.done || '✓ AGREGADO'; }
        }).catch(function () { b.disabled = false; });
      });
    });
  }

  function initVideos(root) {
    root.querySelectorAll('[data-dx-video]').forEach(function (card) {
      var btn = card.querySelector('.dx-vid__play');
      var v = card.querySelector('video');
      if (!btn || !v) return;
      btn.addEventListener('click', function () {
        root.querySelectorAll('video').forEach(function (o) { if (o !== v) { o.pause(); } });
        card.classList.add('is-playing');
        v.setAttribute('controls', '');
        v.play();
      });
    });
  }

  function initBars(root) {
    if (!('IntersectionObserver' in window)) { root.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) { if (e.isIntersecting) { root.classList.add('is-in'); io.disconnect(); } });
    }, { threshold: 0.25 });
    io.observe(root);
  }

  function initTop(btn) {
    window.addEventListener('scroll', function () {
      btn.classList.toggle('is-on', window.scrollY > 700);
    }, { passive: true });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  function initAll(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-dx-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-dx-pdp]').forEach(initProduct);
    scope.querySelectorAll('[data-dx-ugc]').forEach(initVideos);
    scope.querySelectorAll('[data-dx-stats]').forEach(initBars);
    scope.querySelectorAll('[data-dx-top]').forEach(initTop);
  }

  onReady(function () { initAll(document); });
  // Editor de temas: re-iniciar al cambiar secciones
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
